namespace $.$$ {

	const Tool = {
		padding: 0,
		justify: {
			content: 'center',
		},
	} as const

	$mol_style_define( $shm_hitalama_map_book_tools, {

		position: 'absolute',
		top: '4.25rem',
		zIndex: $mol_layer.float,
		gap: '.25rem',
		flex: {
			direction: 'column',
		},
		':hover': {
			zIndex: $mol_layer.float,
		},
		':focus': {
			zIndex: $mol_layer.float,
		},

		Drawing: Tool,
		Rect: Tool,
		Circle: Tool,

		Drawing_icon: {
			width: '1.25rem',
			height: '1.25rem',
		},
		Rect_icon: {
			width: '1.25rem',
			height: '1.25rem',
		},
		Circle_icon: {
			width: '1.25rem',
			height: '1.25rem',
		},

	} )

}
